import React from "react"
import moment from "moment"

const CPSRequestCreated = ({ entry, statusIndex }) => {
  const isActive = entry?.status === "Request Created"
  const isCompleted = [
    "CPS Offer",
    "Customer Decision",
    "Goods Shipped",
    "Goods Received",
    "Sample Production",
    "Sample Approval",
    "Production",
    "Stock Management",
    "Completed",
  ].includes(entry?.status)

  // Get file type based on CPS type
  const getFileTypeLabel = () => {
    if (entry?.type === "Programming") {
      return "Programming Info"
    } else if (entry?.type === "Sleeving") {
      return "Sleeve Instructions"
    }
    return "Files"
  }

  return (
    <li className={"event-list " + (isActive ? "active" : "")}>
      <div
        className={"event-timeline-dot " + (isActive ? "bx-fade-right" : "")}
      >
        <i className="bx bx-right-arrow-circle font-size-18"></i>
      </div>
      <div className="d-flex">
        <div className="flex-shrink-0 me-3">
          <h5 className="font-size-14">
            {entry?.dateCreated
              ? moment(entry.dateCreated).format("DD.MM.YYYY")
              : ""}{" "}
            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
          </h5>
        </div>
        <div className="flex-grow-1">
          <div>
            Request Created{" "}
            {isActive ? " - waiting for offer provided by CPS Lab" : ""}
          </div>
        </div>
      </div>

      {/* Show uploaded file if it exists */}
      {entry?.files && entry.files.length > 0 && (
        <div className="mt-3">
          <div className="d-flex align-items-center mt-2">
            <div style={{ width: "45px" }}>
              <div className="avatar-sm">
                <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-24">
                  <i className="bx bxs-file-doc" />
                </span>
              </div>
            </div>
            <div className="ms-4">
              <h5 className="font-size-14 mb-1">{getFileTypeLabel()}</h5>
              <small>Click To Download</small>
            </div>
            <div className="text-center ms-4">
              <i className="bx bx-download h3 m-0" />
            </div>
          </div>
        </div>
      )}
    </li>
  )
}

export default CPSRequestCreated
